import { useApi } from '@backstage/core-plugin-api';
import { userSettingsApiRef } from '@mercedes-benz/user-settings-react';
import { useEffect, useState } from 'react';
import {
  FEATURE_ACADEMY_PROGRESS_MAP,
  USER_PREFERENCES,
} from '@mercedes-benz/user-settings-common';
import { AcademyEntity } from '@mb.io/catalog-model';
import { useNavigate } from 'react-router-dom';
import { TutorialProgressMap } from '@mercedes-benz/academy-common';

export function useTutorialProgress(entity: AcademyEntity | undefined) {
  const navigate = useNavigate();
  const userSettingsApi = useApi(userSettingsApiRef);
  const [progress, setProgress] = useState('');
  const [isNotificationOpen, setIsNotificationOpen] = useState(true);

  useEffect(() => {
    const redirectToStep = async () => {
      if (!entity) return;

      if (entity?.spec?.codelab && typeof entity?.spec?.codelab === 'object') {
        const key = `progress_${(entity?.spec?.codelab as any)?.id}`;
        localStorage.removeItem(key);
      }

      const setting = await userSettingsApi.get({
        bucket: USER_PREFERENCES,
        key: FEATURE_ACADEMY_PROGRESS_MAP,
      });
      const stored: TutorialProgressMap =
        (setting?.value as unknown as TutorialProgressMap) ?? {};
      const entry = stored[entity.metadata.name];

      const hash = window.location.hash;
      let stepValue: string | undefined;

      if (entry?.progress && !hash) {
        if (entry.progress === 'done') {
          setProgress('restart');
          stepValue = '#0';
        } else {
          setProgress('continue');
          stepValue = entry.progress;
        }
      } else {
        stepValue = hash || undefined;
      }

      if (stepValue) {
        navigate(`${stepValue}`);
      }
    };

    redirectToStep();
  }, [navigate, entity, userSettingsApi]);

  return { progress, isNotificationOpen, setIsNotificationOpen };
}
